export const styles = {
  cardHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  cardColumn: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
};
